<template>
  <div class="youtube-player">
    <slot v-if="!load" :loadPlayer="loadPlayer"></slot>

    <div
      v-if="load && videoSrc"
      class="youtube-player__video has-aspect-ratio" :class="[aspectRatio]" 
    >
      <iframe
        :src="videoSrc"
        :title="videoTitle"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>
    </div>

    <div
      v-if="transcriptHeader"
      class="youtube-player__transcript"
    >
      <details class="accordion" :class="[(!!$slots.transcript || transcript) ? '' : 'nosummary']">
        <summary  v-htmlsafe="transcriptHeader"></summary>
        <div class="accordion__content" v-if="!!$slots.transcript || transcript">
          <p v-if="!!$slots.transcript">
            <slot name="transcript"></slot>
          </p>
          <p v-else v-htmlsafe="transcript" />
        </div>
      </details>
    </div>
  </div>
</template>

<script>
export default {
  name: 'youtube-player',
  props: {
    videoId: {
      type: String,
    },
    privateBrowsing: {
      type: Boolean,
      required: false,
      default: false,
    },
    transcriptHeader: {
      type: String,
      required: true,
    },
    transcript: {
      type: String,
      required: false,
    },
    playVideoAriaLabel: {
      type: String,
      default: 'video',
    },
    autoPlay: {
      type: Boolean,
      required: false,
      default: true,
    },
    autoload: {
      type: Boolean,
      required: false,
      default: false,
    },
    videoTitle: {
      type: String,
      required: false,
      default: 'YouTube video player',
    },
    aspectRatio: {
      type: String,
      default: 'is-16by9'
    }
  },
  data() {
    return {
      load: null,
    };
  },
  beforeMount() {
    this.load = false;
  },
  mounted() {
    if (this.autoload) this.loadPlayer();
  },
  computed: {
    videoSrc() {
      if (!this.videoId) return;
      return (
        `https://www.` +
        `${this.privateBrowsing ? 'youtube-nocookie' : 'youtube'}.com/embed/` +
        `${this.videoId}?` +
        `${this.autoPlay ? 'autoplay=1' : ''}` + '&enablejsapi=1'
      );
    },
  },
  methods: {
    loadPlayer() {
      this.load = true;
    },
  },
};
</script>
